import { render, staticRenderFns } from "./sidebar-menu.vue?vue&type=template&id=00f4de67&scoped=true&"
import script from "./sidebar-menu.vue?vue&type=script&lang=js&"
export * from "./sidebar-menu.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-menu.vue?vue&type=style&index=0&id=00f4de67&lang=scss&scoped=true&"
import style1 from "./sidebar-menu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4de67",
  null
  
)

export default component.exports